module.exports = __webpack_public_path__ + "static/media/Income.f72fc1b2.svg";